import React, { useEffect, useRef, useState } from 'react'
import './ExplorePlans.css';
import '../../components/Buttons/continueenabled.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Container } from 'react-bootstrap';
import loader from './loading.json'
import Lottie from 'lottie-react';

const isMainDomain = () => {
    const hostname = window.location.hostname;
    const mainDomain = process.env.REACT_APP_MAIN_DOMAIN || 'preprod.dastaan.info';
    return hostname === mainDomain || process.env.REACT_APP_DOMAIN === 'main';
};

const PlansV2 = () => {
    const fromMainDomain = isMainDomain();
    const [superPacks, setSuperPack] = useState([])
    const [activePlan, setActivePlan] = useState(2);
    const [activePlanAmnt, setActivePlanAmnt] = useState(42);
    const [loading, setLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const MySwal = withReactContent(Swal);
    const container = useRef(null);
    useEffect(() => {
        fetchData();
        const os = getOS()
    }, []);
    const fetchData = async () => {
        setLoading(true)
        try {
            const data = JSON.stringify({
                'phone': localStorage.getItem('dastaan__phone') !== null ? localStorage.getItem('dastaan__phone') : 1
            });
            let config = {
                method: 'GET',
                maxBodyLength: Infinity,
                url: `${process.env.REACT_APP_API_URL}/plans`,
                headers: {
                    'Authorization': localStorage.getItem('dastaan__token'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios.request(config)
                .then((response) => {
                    // console.log(response.data);
                    setLoading(false)
                    setSuperPack(response.data.plans)
                });
        } catch (err) {
            setLoading(false)
        } finally {
            setLoading(false)
        }
    };
    const getOS = () => {
        const userAgent = window.navigator.userAgent;
        const platform = window.navigator.platform;
        const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
        const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
        const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
        let os = null;
        if (macosPlatforms.includes(platform)) {
            os = 'Mac OS';
        } else if (iosPlatforms.includes(platform)) {
            os = 'iOS';
        } else if (windowsPlatforms.includes(platform)) {
            os = 'Windows';
        } else if (/Android/.test(userAgent)) {
            os = 'Android';
        } else if (!os && /Linux/.test(platform)) {
            os = 'Linux';
        }
        return os;
    };
    const createPaymentMandate = async () => {
        if (isSubmitting) return;
        const current_plan_amnt = parseInt(localStorage.getItem('dastaan__plan_amnt'))
        if (current_plan_amnt > 0) {
            if (current_plan_amnt === activePlanAmnt && localStorage.getItem('is_subscription_cancelled') === 'false') {
                Swal.fire({
                    title: "Plan is already purchased",
                    background: "#000"
                });
            }
            else if (current_plan_amnt < activePlanAmnt) {
                MySwal.fire({
                    title: 'Are you sure want to upgrade the plan?',
                    background: "#000",
                    // text: 'You cannot undo this action.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                }).then((result) => {
                    if (result.isConfirmed) {
                        checkoutPayment()
                    }
                });
                //  confirm('.')
            }
            else if (current_plan_amnt > activePlanAmnt) {
                MySwal.fire({
                    title: 'Are you sure want to downgrade the plan?',
                    // text: 'You cannot undo this action.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                }).then((result) => {
                    if (result.isConfirmed) {
                        checkoutPayment()
                    }
                });
                //  confirm('Are you sure want to downgrade the plan.')
            }
            else {
                checkoutPayment()
            }
        }
        else {
            checkoutPayment()
        }
    }

    // Added By: Pradyumn Dwivedi; Added on: 29 July 2024; Use: To initialize Facebook Pixel for tracking events
    useEffect(() => {
        // Initialize Facebook Pixel with your Pixel ID
        if (window.fbq) {
            window.fbq('init', '1310440030053294');
            window.fbq('track', 'PageView');
        }
    }, []);

    // Added By: Pradyumn Dwivedi; Added on: 29 July 2024; Use: To track a purchase event
    const handlePurchase = () => {
        if (window.fbq) {
            window.fbq('track', 'Purchase', {
                value: 142.52,
                currency: 'USD'
            });
        }
    };

    const checkoutPayment = () => {
        setIsSubmitting(true);
        setLoading(true)
        const data = JSON.stringify({
            'plan_id': activePlan,
            'user_id': localStorage.getItem('dastaan__user_id'),
        });
        console.log(data);
        let config = {
            method: 'POST',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}/payu-create-intent`,
            headers: {
                'Authorization': localStorage.getItem('dastaan__token'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            data: data
        };
        axios.request(config).then((response) => {
            if (response.data.data !== undefined) {
                // Added By: Pradyumn Dwivedi; Added on: 29 July 2024; Use: To track the purchase event
                handlePurchase();

                // setShowPayButton(true)
                const redirectUrl = response?.data?.data?.redirect_url !== undefined ? response?.data?.data?.redirect_url : null;
                const txnid = response?.data?.data?.txnid !== undefined ? response?.data?.data?.txnid : null;
                console.log(txnid);
                window.location.href = redirectUrl;
                const postdata = JSON.stringify({
                    'user_id': localStorage.getItem('dastaan__user_id'),
                    'txnid': txnid ?? null,
                });
                let upiAppOpened = false;

                const resetLoader = () => {
                    setLoading(false);
                    setIsSubmitting(false);
                    document.removeEventListener('visibilitychange', handleVisibility);
                };

                const handleVisibility = () => {
                    if (document.hidden) {
                        upiAppOpened = true; // user opened a UPI app
                    } else if (upiAppOpened) {
                        resetLoader(); // user came back from UPI app
                    }
                };

                document.addEventListener('visibilitychange', handleVisibility);

                // Fallback: if page never went hidden within 4s, chooser was cancelled
                setTimeout(() => {
                    if (!upiAppOpened) resetLoader();
                }, 4000);
                /*  let config = {
                     method: 'POST',
                     maxBodyLength: Infinity,
                     url: `${process.env.REACT_APP_API_URL}/payu-payment-status`,
                     headers: {
                         'Authorization': localStorage.getItem('dastaan__token'),
                         'Accept': 'application/json',
                         'Content-Type': 'application/json'
                     },
                     data: postdata
                 };
                 setTimeout(() => {
                     axios.request(config).then((response) => {
                         console.log(response.data);
                         if (response?.data?.exp_date != null && response?.data?.exp_date != undefined) {
                             toast('Payment Successful');
                         } else{
                             toast('Payment Failed OR still pending...');
                         }
                     }).catch((error) => {
                         console.error('Error fetching payment status:', error);
                     });
                     setLoading(false)
                 }, 8000); // Polling every 5 seconds */
            } else {
                setIsSubmitting(false);
                setLoading(false);
            }
        }).catch(() => {
            setIsSubmitting(false);
            setLoading(false);
        })
    }
    /*
        const [superPacks, setSuperPack] = useState([])
        const [activePlan, setActivePlan] = useState(1);
        // const [mandateURL, setMandateUrl] = useState(null);
        const [paybutton, setShowPayButton] = useState(false)
        const [show, setShow] = useState(false);
        const handleClose = () => setShow(false);
        // const handleShow = () => setShow(true);
        const [vpa, setVPA] = useState(null);
        useEffect(() => {
            fetchData();
            const os = getOS()
            console.log(os);
        }, []);
        const getOS = () => {
            const userAgent = window.navigator.userAgent;
            const platform = window.navigator.platform;
            const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
            const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
            const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
            let os = null;
            if (macosPlatforms.includes(platform)) {
                os = 'Mac OS';
            } else if (iosPlatforms.includes(platform)) {
                os = 'iOS';
            } else if (windowsPlatforms.includes(platform)) {
                os = 'Windows';
            } else if (/Android/.test(userAgent)) {
                os = 'Android';
            } else if (!os && /Linux/.test(platform)) {
                os = 'Linux';
            }
            return os;
        };
        const fetchData = async () => {
            setLoading(true)
            try {
                const data = JSON.stringify({
                    'phone': localStorage.getItem('dastaan__phone') !== null ? localStorage.getItem('dastaan__phone') : 1
                });
                let config = {
                    method: 'GET',
                    maxBodyLength: Infinity,
                    url: `${process.env.REACT_APP_API_URL}/plans`,
                    headers: {
                        'Authorization': localStorage.getItem('dastaan__token'),
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    data: data
                };
                axios.request(config)
                    .then((response) => {
                        // console.log(response.data);
                        setLoading(false)
                        setSuperPack(response.data.plans)
                    });
            } catch (err) {
                setLoading(false)
                // setError(err);
            } finally {
                // setLoading(false);
            }
        };
        const handleVPA = (event) => {
            setVPA(event.target.value);
        }
        const createPaymentMandate = async () => {
            setLoading(true)
            const data = JSON.stringify({
                'plan_id': activePlan,
                'user_id': localStorage.getItem('dastaan__user_id'),
            });
            let config = {
                method: 'POST',
                maxBodyLength: Infinity,
                url: `${process.env.REACT_APP_API_URL}/payu-create-intent`,
                headers: {
                    'Authorization': localStorage.getItem('dastaan__token'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios.request(config).then((response) => {
                if (response.data.data !== undefined) {
                    // setShowPayButton(true)
                    const redirectUrl = response?.data?.data?.redirect_url !== undefined ? response?.data?.data?.redirect_url : null;
                    const txnid = response?.data?.data?.txnid !== undefined ? response?.data?.data?.txnid : null;
                    console.log(txnid);
                    window.location.href = redirectUrl
                    const postdata = JSON.stringify({
                        'user_id':localStorage.getItem('dastaan__user_id'),
                        'txnid': txnid ?? null,
                    });
                    setTimeout(() => {
                        setLoading(false)
                        window.location.href = '/';
                    }, 10000);
                }
            })
        }
        const changePlan = (id) => {
            setActivePlan(id)
        }
        const handleWebPayment = (e) => {
            e.preventDefault();
            const formData = new FormData();
            formData.append('plan_id', activePlan)
            formData.append('mobileNumber', localStorage.getItem('dastaan__phone'))
            formData.append('subscriptionName', 'Daily')
            formData.append('merchantUserId', localStorage.getItem('dastaan__user_id'))
            formData.append('user_id', localStorage.getItem('dastaan__user_id'))
            formData.append('upi_id', vpa)
            const config = {
                method: 'POST',
                maxBodyLength: Infinity,
                url: `${process.env.REACT_APP_API_URL}/create-phonepe-subscription-vpa`,
                // url: `https://tamashatv.com/create_user_subscription`,
                headers: {
                    'Authorization': localStorage.getItem('dastaan__token'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: formData
            }
            axios.request(config).then((response) => {
                console.log(response);
                const msg = response.data.message;
                setShow(false)
                toast(msg);
                setVPA(null)
            })
            //
        }
        const handleVPAVerification = async () => {
            console.log(vpa);
            const baseURL = 'https://api.phonepe.com/apis/hermes';
            const endpoint = '/v1/vpa/validate';
            const apiKey = '4865f6b1-9e26-47ee-bc4f-b1febdff78e5'; // Replace with your API key
            const saltKey = '1'; // Replace with your salt key
            const merchantId = 'TAMASHATVONLINE'; // Replace with your merchant ID
            const vpaToVerify = vpa;
            const payload = {
                merchantId,
                //   transactionId: 'UNIQUE_TRANSACTION_ID', // Generate a unique transaction ID
                vpa: vpaToVerify
            };
            const payloadString = JSON.stringify(payload);
            const checksum = crypto.createHash('sha256').update(payloadString + saltKey).digest('hex');
            try {
                const response = await axios.post(`${baseURL}${endpoint}`, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-VERIFY': `${checksum}###${saltKey}`,
                        'accept': 'application/json',
                        'X-CLIENT-ID': apiKey
                    }
                });
                if (response.data.success) {
                    console.log('VPA is valid');
                    // Handle success case
                } else {
                    console.log('VPA is invalid');
                    // Handle failure case
                }
            } catch (error) {
                console.error('Error verifying VPA:', error.response ? error.response.data : error.message);
                // Handle error case
            }
        }
    */
    return (
        <>
            {
                loading === false ? (
                    <>
                        <Container className='plan-section' style={{
                            minHeight: '100vh',
                            width: '100%',
                            backgroundImage: `url(${process.env.PUBLIC_URL}/images/${fromMainDomain ? 'modal-bg.jpg' : 'modal-bg-login.jpg'})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            position: 'absolute'
                        }}>

                            <div className="plans-container">
                                <div style={{ display: 'flex', justifyContent: 'flex-end', minHeight: '28px', marginBottom: '4px' }}>
                                    {fromMainDomain && (
                                        <button
                                            onClick={() => { window.location.href = process.env.REACT_APP_MAIN_DOMAIN_URL || `https://${process.env.REACT_APP_MAIN_DOMAIN || 'preprod.dastaan.info'}/`; }}
                                            style={{
                                                background: 'transparent',
                                                border: 'none',
                                                color: 'rgba(255,255,255,0.75)',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                cursor: 'pointer',
                                                letterSpacing: '0.3px',
                                                padding: '4px 2px',
                                            }}
                                        >
                                            Skip &rsaquo;
                                        </button>
                                    )}
                                </div>
                                <h2 className="heading">EXPLORE PLANS</h2>
                                {
                                    superPacks.map(plan => {
                                        const amnt = plan.plan_price - plan.discount;
                                        return (
                                            <div
                                                key={plan.id}
                                                className={`plan-box ${activePlan === plan.id ? 'selected' : ''}`}
                                                onClick={() => { setActivePlan(plan.id); setActivePlanAmnt(amnt) }} >
                                                <div className="left-section">
                                                    <div className="radio-btn">
                                                        <div className={`dot ${activePlan === plan.id ? 'active' : ''}`} />
                                                    </div>
                                                    <span className="plan-name">{plan.plan_name}</span>
                                                    {plan.id === 2 && <span className="recommended-tag">Recommended</span>}
                                                </div>
                                                <div className="right-section">
                                                    <div className="price-wrapper">
                                                        <div className="price">
                                                            ₹ <span className="bold">{(plan.plan_price) - plan.discount}</span>{' '}
                                                            <span className="striked">₹{plan.plan_price}</span>
                                                        </div>
                                                        <div className={`${activePlan === plan.id && 'off-badge-selected'} off-badge`}>
                                                            <strong>{plan.discount_percent} %</strong>
                                                            <span>Off</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                <button
                                    className="pay-now"
                                    onClick={createPaymentMandate}
                                    disabled={isSubmitting}
                                    style={isSubmitting ? { opacity: 0.6, cursor: 'not-allowed' } : {}}
                                >
                                    {isSubmitting ? 'Please wait...' : 'Pay Now'}
                                </button>
                                {/* {fromMainDomain && (
                                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '12px' }}>
                                        <button
                                            className='skip-btn'
                                            style={{ maxWidth: '280px' }}
                                            onClick={() => { window.location.href = process.env.REACT_APP_MAIN_DOMAIN_URL || `https://${process.env.REACT_APP_MAIN_DOMAIN || 'preprod.dastaan.info'}/`; }}
                                        >
                                            Skip for now
                                        </button>
                                    </div>
                                )} */}
                            </div>
                        </Container>
                    </>
                ) : (
                    <>
                        <div className='center'>
                            <Lottie animationData={loader} loop={true}
                                className='loader'
                            />
                        </div>
                    </>
                )
            }
        </>
    )
}
export default PlansV2
